// src/index.ts
import { AnswerSession as OSSAnswerSession, search } from "@orama/orama";
import { CollectionManager } from "@orama/core";
function isOramaClient(client) {
  return client && typeof client === "object" && "api_key" in client && "endpoint" in client;
}
function isOramaCoreClient(client) {
  return client && (client instanceof CollectionManager || client.constructor.name === "CollectionManager");
}
function isOramaJSClient(client) {
  return client && typeof client === "object" && "id" in client && "tokenizer" in client;
}
var Switch = class {
  invalidClientError = "Invalid client. Expected either an OramaClient, CollectionManager, or an Orama JS database.";
  client;
  clientType;
  isCloud = false;
  isJS = false;
  isCore = false;
  constructor(client) {
    this.client = client;
    switch (true) {
      case isOramaCoreClient(client):
        this.clientType = "core";
        this.isCore = true;
        break;
      case isOramaClient(client):
        this.clientType = "cloud";
        this.isCloud = true;
        break;
      case isOramaJSClient(client):
        this.clientType = "oss";
        this.isJS = true;
        break;
      default:
        throw new Error(this.invalidClientError);
    }
  }
  async search(params, config) {
    switch (true) {
      case this.isCloud:
        return this.client.search(
          params,
          config
        );
      case this.isCore: {
        const results = await this.client.search(
          params
        );
        return results;
      }
      case this.isJS:
        return search(
          this.client,
          params
        );
      default:
        throw new Error(this.invalidClientError);
    }
  }
  createAnswerSession(params) {
    switch (true) {
      case this.isCloud: {
        const p = params;
        return this.client.createAnswerSession(
          p
        );
      }
      case this.isCore: {
        const p = params;
        return this.client.createAnswerSession(
          p
        );
      }
      case this.isJS: {
        const p = params;
        return new OSSAnswerSession(this.client, {
          conversationID: p.conversationID,
          initialMessages: p.initialMessages,
          events: p.events,
          userContext: p.userContext,
          systemPrompt: p.systemPrompt
        });
      }
      default:
        throw new Error(this.invalidClientError);
    }
  }
};
export {
  Switch
};
//# sourceMappingURL=index.js.map